import { useState } from 'react';

import { Label, Select } from '@iwoca/orion';
import { t } from '@lingui/core/macro';

import styles from './ManualUploadDE.module.css';
import { fetchPutAndGetState } from '../../../../../api/lendingApi/lendingApiMutations';
import { useGetStateQuery } from '../../../../../api/lendingApi/lendingApiQueries';
import { useContextStateKey } from '../../../../../hooks/useContextStateKey';
import { useOffersDE } from '../../../../../hooks/useOffers/useOffersDE';
import { TOfferDataRequirement } from '../../../../../types';
import DocumentRequirement from '../../../DocumentRequirement/DocumentRequirement';

type TProps = {
  title: string;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
const ManualUploadDE = ({ status, isSubmitted }: TProps) => {
  const { state } = useGetStateQuery();
  const stateKey = useContextStateKey();

  const { setIsSyncingState } = useOffersDE();

  const [showManualUploadButton, setShowManualUploadButton] = useState(false);

  const manualUploadReasons = [
    {
      value: 1,
      text: 'Ich habe kein Online Banking.',
    },
    {
      value: 2,
      text: 'Ich finde PDF hochladen einfacher.',
    },
    {
      value: 3,
      text: 'Ich konnte meine Bank nicht finden.',
    },
    {
      value: 4,
      text: 'Ich vertraue der Open Banking Lösung nicht.',
    },
    {
      value: 5,
      text: 'Ich finde, dass ich mit Open Banking mehr Informationen teile als notwendig.',
    },
    {
      value: 6,
      text: 'Ich möchte die Frage nicht beantworten.',
    },
  ];

  const submitManualReason = async (manualReasonData: string) => {
    setIsSyncingState(true);
    const putStateBody = {
      data: {
        ...state,
        ui: {
          ...state.ui,
          OB_not_linked_reason: manualReasonData,
        },
      },
    };

    // @ts-expect-error: mismatch type
    await fetchPutAndGetState({ body: putStateBody, stateKey });
    setIsSyncingState(false);
  };

  return (
    <DocumentRequirement
      className={styles.documentRequirement}
      documentType="bank statement"
      isSubmitted={isSubmitted}
      status={status}
      customButton={showManualUploadButton ? null : <></>}
    >
      <>
        <ul>
          <li>
            Sie können sich die Kontoauszüge in Ihrem Online Banking
            herunterladen
          </li>
          <li>
            Laden Sie die Umsätze im PDF-Format mit vollständigem Buchungstext
            hoch
          </li>
          <li>Jede Datei darf max. 50MB groß sein</li>
          <li>
            Stellen Sie sicher, dass die Dateien nicht passwortgeschützt sind
            (oder teilen Sie das Passwort mit uns)
          </li>
          <li>
            Die Konten müssen mindestens die Buchungen der letzten 90 Tage
            umfassen.
          </li>
          <li>
            Wir benötigen alle Konten, die mehr als 10% Ihres Gesamtumsatzes
            ausmachen.
          </li>
        </ul>

        <div className={styles.manualReasonsContainer}>
          <Label
            htmlFor="manual-bank-statement-reason"
            className={styles.manualSelectTitle}
          >
            {t`Select an option below to manually upload bank statements`}
          </Label>
          <Select
            defaultValue="none"
            name="manual-bank-statement-reason"
            className={styles.manualSelectInput}
            onChange={(e) => {
              if (e.target.value !== 'none') {
                setShowManualUploadButton(true);
                submitManualReason(e.target.value);
              }
            }}
          >
            <optgroup label="Ich kann mein Bankkonto nicht verknüpfen">
              <option disabled hidden value="none">
                Bitte wählen Sie eine Option aus
              </option>
              {manualUploadReasons.map((manualreason) => (
                <option key={manualreason.value} value={manualreason.text}>
                  {manualreason.text}
                </option>
              ))}
            </optgroup>
          </Select>
        </div>
      </>
    </DocumentRequirement>
  );
};

export default ManualUploadDE;
